export default "__VITE_ASSET__BmpXHkxt__"